import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Política de Privacidad
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          1. Introducción
        </Typography>
        <Typography>
          Esta Política de Privacidad describe cómo recopilamos, usamos y protegemos la información personal de nuestros usuarios. Al utilizar nuestra plataforma, usted acepta los términos de esta política.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          2. Información que Recopilamos
        </Typography>
        <Typography>
          Recopilamos información personal que usted nos proporciona al registrarse en nuestra plataforma, como su nombre, dirección de correo electrónico, número de teléfono y cualquier otra información que decida compartir. También podemos recopilar información sobre su actividad en nuestra plataforma, como las páginas que visita y los productos que consulta.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          3. Uso de la Información
        </Typography>
        <Typography>
          Utilizamos la información recopilada para:
          <ul>
            <li>Proporcionar y mejorar nuestros servicios.</li>
            <li>Comunicarle información sobre su cuenta y nuestros servicios.</li>
            <li>Personalizar su experiencia en nuestra plataforma.</li>
            <li>Enviarle promociones y ofertas que puedan interesarle.</li>
            <li>Realizar análisis y estudios para mejorar nuestros servicios.</li>
          </ul>
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          4. Protección de la Información
        </Typography>
        <Typography>
          Implementamos medidas de seguridad adecuadas para proteger su información personal contra el acceso no autorizado, la divulgación, la alteración o la destrucción. Sin embargo, ningún método de transmisión por Internet o método de almacenamiento electrónico es 100% seguro, por lo que no podemos garantizar su seguridad absoluta.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          5. Compartición de Información
        </Typography>
        <Typography>
          No vendemos, intercambiamos ni transferimos su información personal a terceros sin su consentimiento, excepto en los siguientes casos:
          <ul>
            <li>Cuando sea necesario para proporcionar nuestros servicios.</li>
            <li>Para cumplir con la ley o responder a un proceso legal.</li>
            <li>Para proteger nuestros derechos o los derechos de otros.</li>
          </ul>
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          6. Sus Derechos
        </Typography>
        <Typography>
          Usted tiene derecho a acceder, corregir o eliminar su información personal. Si desea ejercer estos derechos, puede contactarnos a través de nuestro formulario de contacto.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          7. Cambios a esta Política
        </Typography>
        <Typography>
          Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento. Cualquier cambio será efectivo una vez publicado en esta página. Le recomendamos que revise esta política periódicamente para estar informado sobre cómo protegemos su información.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          8. Contacto
        </Typography>
        <Typography>
          Si tiene alguna pregunta sobre esta Política de Privacidad, no dude en contactarnos a través de nuestro formulario de contacto.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy; 